import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Analytics from './Analytics';
import FamilyFinderRoute from './family-finder/pages/FamilyFinderRoute';
import SupervisionRoute from './family-finder/pages/SupervisionRoute';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <> {/* React.StrictMode temporarily disabled to fix canvas duplication */}
    <Analytics />
      <Router>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/child/:childId/family-finder" element={<FamilyFinderRoute />} />
          <Route path="/supervision" element={<SupervisionRoute />} />
        </Routes>
      </Router>
  </>
);

reportWebVitals();
